// Registriert den Service Worker für die PWA (Installierbarkeit + Offline-Shell).
// WICHTIG: Push ist V2 — hier wird BEWUSST keine Push-Subscription angelegt
// (kein PushManager.subscribe, kein push_subscriptions-Eintrag).
export async function registerServiceWorker(): Promise<void> {
  if (typeof navigator === 'undefined' || !('serviceWorker' in navigator)) return
  try {
    await navigator.serviceWorker.register('/sw.js')
  } catch {
    // Registrierung ist best-effort; Fehler dürfen die App nicht blockieren.
  }
}
